// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPopover.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import FloatAffixed from 'share/components/controls/Izenda.FloatAffixed';
import OperatorGroup from 'modules/ReportDesigner/Fields/Filter/Izenda.OperatorGroup';
import OperatorValue from 'modules/ReportDesigner/Fields/Filter/Izenda.OperatorValue';
import { ACCESS_RIGHT } from 'logic/data/Izenda.AuthorizationConstants';
import PropTypes from 'prop-types';
import CONSTANTS from 'logic/data/Izenda.FilterDetailsConfigConstants';
import { isEmpty, any, noop, isObject } from 'lodash/fp';

const MIN_WIDTH = 500;

@connect()
export default class FilterPopover extends PureComponent {
  static propTypes = {
    anchor: PropTypes.object.isRequired,
    itemData: PropTypes.object.isRequired,
    viewMode: PropTypes.bool,
    closePopover: PropTypes.func,
    fieldStore: PropTypes.object,
    index: PropTypes.number,
    updateCascadingValue: PropTypes.func,
    isLazyLoading: PropTypes.bool
  }

  // Indicates if should keep showing popover
  keepShowing: boolean = false;

  /**
   * Update keep or not showing popover
   * @param {boolean} doesKeep
   */
  updateKeepShowingHost = (doesKeep: boolean) => {
    this.keepShowing = doesKeep;
  };

  /**
   * Close popover
   */
  closePopover = () => {
    !this.keepShowing && this.props.closePopover();
  };

  /**
   * Handle change of operator value.
   * @param {string} value
   */
  onChangeOperatorValue = (value: string): void => {
    const { props } = this;
    const itemData = props.itemData || {};
    itemData.setFilterValue && itemData.setFilterValue(value);
    if(isObject(props.fieldStore) && props.fieldStore.updateReportDesignerCascadingFilter)
      props.fieldStore.updateReportDesignerCascadingFilter(itemData.fieldDetails);
  };

  /**
   * Check need to render operator.
   * @param {String} operatorGroupName
   * @param {String} operatorName
   */
  doesRenderOperator(operatorGroupName: string, operatorName: string): boolean {
    return (
      operatorGroupName === CONSTANTS.OPERATOR_GROUP_KEYS.BOOLEAN ||
      any(value => operatorName === value, CONSTANTS.OPERATOR_KEYS)
    );
  }

  /**
   * Render operator component.
   */
  renderOperator() {
    const {
      props,
      props: { isLazyLoading, fieldStore: { reportFilters } }
    } = this;
    const itemData = props.itemData || {};
    const filterInfo = itemData.filterInfo;

    if (!this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

    return (
      <OperatorGroup
        notInReportDesignerMode
        configField={itemData}
        updateSourceValue={noop}
        isLazyLoading={isLazyLoading}
        renderInContainer={false}
        reportFilters={reportFilters}
        updateKeepShowingHost={this.updateKeepShowingHost}
      />
    );
  }

  /**
   * Render operator value component.
   */
  renderOperatorValue() {
    const { fieldStore, itemData = {}, viewMode, index, accessPriority, isLazyLoading } = this.props;
    const filterInfo = itemData.filterInfo;
    const filterSource = itemData.operatorSourceValue;

    if (this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

    return (
      <OperatorValue
        className='u_noMarginTop'
        filterSource={filterSource}
        filterInfo={filterInfo}
        configField={itemData}
        operatorGroup={itemData}
        onChange={this.onChangeOperatorValue}
        index={index}
        viewMode={viewMode}
        disabled={accessPriority === ACCESS_RIGHT.Locked}
        store={fieldStore}
        isLazyLoading={isLazyLoading}
        renderInContainer={false}
        updateKeepShowingHost={this.updateKeepShowingHost}
      />
    );
  }

  render() {
    const { anchor } = this.props;

    return (
      !isEmpty(anchor) && (
        <FloatAffixed onClickOutside={this.closePopover} anchor={anchor} minWidth={MIN_WIDTH} autoWidth>
          <div className='izenda-FilterPopover'>
            {this.renderOperator()}
            {this.renderOperatorValue()}
          </div>
        </FloatAffixed>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/FilterProperty/Izenda.FilterPopover.js